
export const markAsReadPersonalMessage=(count) => {
    return {
      type:"MARK_AS_READ_PERSONAL_MESSAGE",
      count,
      segmentName: "personalMessageCount",
    }
  }
